export const SMALL_LINE_CHART_STYLES = {
  width: "100%",
  height: "100%",
  margin: { top: 0, right: 0, bottom: 0, left: 0 },
  opacity: 0.3,
  strokeWidth: 2,
};
